export default {
    getSearchTerm: state => {
      return state.searchTerm;
    },
    getSearchResult:state => {
      return state.searchResult;
    },
    getSearchStatus: state =>{
        return state.serverError;
    }
  };
   